export const isValidNumber = (val: string | number | null): boolean =>
  val !== null && val !== "" && !Number.isNaN(Number(val));
